import * as React from 'react';

/**
 * @description hook that takes multiple dependencies but only runs when specific ones change
 * @param effect
 * @param deps
 * @param whenDeps
 * @returns
 */
export const useEffectWhen = (
  effect: () => void | (() => void),
  deps: React.DependencyList,
  whenDeps: React.DependencyList
): void => {
  const whenRef = React.useRef(whenDeps || []);
  const initial = whenRef.current === whenDeps;
  const whenDepsChanged =
    initial ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    !whenRef.current.every((w: any, i: number): boolean => w === whenDeps[i]);
  whenRef.current = whenDeps;
  const nullDeps = deps.map((): null => null);

  return React.useEffect(
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    whenDepsChanged ? effect : (): void => {},
    whenDepsChanged ? deps : nullDeps
  );
};
